import React from 'react'
import {useNavigate} from 'react-router-dom';
import './css/homeBtn.css'
import { IoHome } from "react-icons/io5";

const HomeBtn = () => {

const navigate = useNavigate();

const Home = () =>{
    navigate("../event");
}

  return (
    <div>
            <IoHome size={45} onClick={Home} className='btn' id="HomeBtn"/>
    </div>
  )
}

export default HomeBtn
